import { Fragment as _Fragment, jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import React, { createContext, useEffect } from 'react';
import { redirect, RouterContext } from './Router';
export const RouteVariableContext = createContext({});
export function useParams() {
    const ctx = React.useContext(RouteVariableContext);
    return ctx.params;
}
export function useRouteQuery() {
    const ctx = React.useContext(RouteVariableContext);
    return ctx.query;
}
function matchPath(browserPath, route) {
    if (route == browserPath)
        return {};
    const curly = route.indexOf('{');
    if (curly > 0) {
        if (!browserPath.startsWith(route.slice(0, curly)))
            return undefined;
        const parts = (route.endsWith('/*') ? route.slice(0, -1) : route).split('/');
        const bParts = browserPath.split('/');
        if (parts.length != bParts.length && !route.endsWith('/*'))
            return undefined;
        const vars = {};
        let defaultVar = 0;
        for (let i = 0; i < parts.length; i++) {
            if (parts[i].startsWith('{') && parts[i].endsWith('}')) {
                vars[parts[i].slice(1, -1) || defaultVar++] = bParts[i];
            }
            else if (parts[i] != bParts[i])
                return undefined;
        }
        return vars;
    }
    if (route.endsWith('/*')) {
        const prefix = route.slice(0, -1);
        if (browserPath.startsWith(prefix))
            return {};
    }
    return undefined;
}
function findRoute(routes, path, query) {
    for (const route of routes) {
        const params = matchPath(path, route.path);
        if (params) {
            return { route, params, query: query ? Object.fromEntries(new URLSearchParams(query)) : {} };
        }
    }
    return undefined;
}
/**
 * Adds handler to be called when the user navigates away from the page.
 * @param handler The handler to call. If it returns false, the navigation is canceled.
 * @param enabled If false, the handler is not called.
 */
export function useOnUnload(handler, enabled = true) {
    useEffect(() => {
        if (!enabled)
            return;
        const unload = (e) => {
            if (!handler())
                e.preventDefault();
        };
        window.addEventListener('beforeunload', unload);
        return () => window.removeEventListener('beforeunload', unload);
    }, [handler, enabled]);
}
/*
 * Defines a 'window' in the router container that changes depending on the current path.
 */
const Routes = ({ routes }) => {
    var _a, _b, _c;
    const routerCtx = React.useContext(RouterContext);
    const { path } = routerCtx;
    const pathName = path === null || path === void 0 ? void 0 : path.replace(/[\?#].*$/, '');
    const query = (_a = path === null || path === void 0 ? void 0 : path.replace(/^[^?]*\?/, '?')) === null || _a === void 0 ? void 0 : _a.replace(/#.*$/, '');
    const sPath = ((_c = (_b = pathName === null || pathName === void 0 ? void 0 : pathName.replace(/^([^/])/, '/$1')) === null || _b === void 0 ? void 0 : _b.replace(/\/$/, '')) === null || _c === void 0 ? void 0 : _c.replace(/\/\/+/, '/')) || '/';
    const match = findRoute(routes, sPath, query);
    if (!match)
        return _jsxs(_Fragment, { children: ["No route found for ", sPath] });
    if (match.route.component)
        return _jsx(RouteVariableContext.Provider, { value: { params: match.params, query: match.query }, children: match.route.component });
    else
        return _jsx(_Fragment, { children: redirect(routerCtx, match.route.redirect) });
};
export default Routes;
